const withProtocol = (url) => {
  if (!url || /^((https?|ftps?):\/\/|blob:|data:)/i.test(url)) return url;

  return `https://${url.replace(/^\/\//, "")}`;
};

export default withProtocol;
